<template>
  <div class="appNavbar">
    <div class="col-md-4 col-xs-4 col-lg-4">
      <router-link to="/menu">
        <i class="fa fa-home"></i>
        Home
      </router-link>
    </div>
    <div class="col-md-4 col-xs-4 col-lg-4">
      <router-link v-if="!$payInvNo" to="/cart">
        <i class="fa fa-shopping-cart"></i>
        Cart
      </router-link>
      <span v-else class="action" v-on:click="pay">
        <i class="fa fa-money"></i>
        SnapnPay
      </span>
    </div>
    <div class="col-md-4 col-xs-4 col-lg-4">
      <a href="#" v-if="$isLoggedIn" class="action" v-on:click="logout">
        <i class="fa fa-sign-out"></i>
        Logout
      </a>
      <router-link v-if="!$isLoggedIn" to="/login">
        <i class="fa fa-sign-in"></i>
        Login
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
      this.logoutUser();
    },
    pay() {
      var _self = this;
      if (this.$route.name != 'Pay')
        _self.$router.push({
          path: 'Pay',
          query: {
            fid: _self.$payFID,
            bid: _self.$payBID,
            invNo: _self.$payInvNo,
          },
        });
    },
  },
  mounted() {
    this.isLoggedIn = localStorage.userMembershipID != null;
  }
};
</script>
<!-- Styles -->
<style scoped>
/* APP FOOTER */
.appNavbar {
  overflow: hidden;
  background-color: #333;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  color: #adadad;
  z-index: 2;
}

.appNavbar div {
  display: inline-block;
  text-align: center;
  padding: 10px;
}

.appNavbar div a:hover {
  color: #fff;
}

.appNavbar div a,
.appNavbar div span {
  color: #8a8a8a;
}

.appNavbar div i {
  display: block;
}
</style>